import { getColorFromString } from "@repo/ui/charts/googleMaps/color";

import type { PositionViewModel } from "../../../models/location";
import type { LayerDefinition } from "../../../models/mapConfiguration";

import { MapPins } from "../../../constants/mapPins";
import { positionGroupKey } from "../hooks/queries/positionGrouping";

export const RAINBOW = "rainbow";

export const LAYER_COLORS = [
	{ name: "Green", value: "#22c55e" },
	{ name: "Blue", value: "#3b82f6" },
	{ name: "Red", value: "#ef4444" },
	{ name: "Orange", value: "#f59e0b" },
	{ name: "Purple", value: "#8b5cf6" },
	{ name: "Pink", value: "#ec4899" },
	{ name: "Cyan", value: "#06b6d4" },
	{ name: "Yellow", value: "#eab308" },
];

export const RAINBOW_COLOR = { name: "Rainbow", value: RAINBOW };

const ICON_IMAGES: Record<string, string> = {
	pin: MapPins.pin,
	flag: MapPins.flag,
	gpin: MapPins.gPin,
	person: MapPins.person,
	office: MapPins.office,
	store: MapPins.store,
};

export function defaultLayerColor(index: number) {
	return LAYER_COLORS[index % LAYER_COLORS.length].value;
}

export function layerIconImage(icon: string | undefined) {
	return ICON_IMAGES[(icon ?? "pin").toLowerCase()] ?? MapPins.pin;
}

export function layerItemColor(
	layer: Pick<LayerDefinition, "color" | "itemType">,
	item: Pick<PositionViewModel, "key" | "displayFields">,
) {
	return layer.color === RAINBOW ? getColorFromString(positionGroupKey(layer.itemType, item)) : layer.color;
}
